class ProductCardContent extends HTMLElement {
    connectedCallback () {
      // listen for click events if media-carousel doesn't exist in the product card
      this.addEventListener('click', (ev) => {
        if (ev.target.nodeName === 'A') return;
        ev.preventDefault();
        this.querySelector('a')?.click();
      });

      // @todo: move this functionality up where it belongs
      const productCard = this.closest('.product-card');
      if (productCard && !productCard.querySelector('mobile-swipe')) {
        productCard.querySelector('.product-card__media')?.addEventListener('click', (ev) => {
            if (ev.target.nodeName === 'IMG') {
                this.querySelector('a')?.click();
            }
        });
      }
    }
  }
  
  customElements.define('product-card-content', ProductCardContent);
  